


























import {Component, Vue} from 'vue-property-decorator';
import ICognitoUserData from '@/types/cognitoUserData';
import {
  Getter,
  Action,
} from 'vuex-class';
import {Auth} from 'aws-amplify';

@Component
export default class GuestHero extends Vue {
}
